<template>
    <app-avatars-group :avatars-group-class="avatarsGroupClass" :name="avatarsGroupName+index" :shadow="false" :border="true" :avatars="trainings"/>
</template>

<script>
    export default {
        name: "GroupOfTrainings",
        props: {
            value: {},
            rowData: {},
            index: {}
        },
        data(){
            return {
                avatarsGroupClass: 'avatars-group-w-50',
                avatarsGroupName: 'groupOftrainings',
            }
        },
        computed:{
            trainings(){
                let trainings = this.value;
                trainings.map(item => {
                    item.img = item.certificate?.logo;
                    item.alt = item.certificate?.title;
                    item.title = item.certificate?.title;
                });
                return trainings;
            }
        }
    }
</script>
